/* Armovac theme JS — header scroll state, mobile menu, reveal-on-scroll (ported from home mock v4). */
(function () {
  var header = document.getElementById('header');
  var menuBtn = document.getElementById('menuBtn');
  var mobile = document.getElementById('mobileNav');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (menuBtn && mobile) {
    var close = function () {
      mobile.classList.remove('is-open'); mobile.hidden = true;
      menuBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = '';
    };
    menuBtn.addEventListener('click', function () {
      var open = mobile.classList.toggle('is-open');
      mobile.hidden = !open;
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobile.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  }

  // Reveal animation: only when JS + IntersectionObserver available and not in theme editor / ?noanim
  var designMode = window.Shopify && window.Shopify.designMode;
  if (!designMode && 'IntersectionObserver' in window && location.search.indexOf('noanim') < 0 &&
      !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    document.documentElement.classList.add('js-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    setTimeout(function () { document.querySelectorAll('.hero .reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 40);
  }

  // Product page: gallery thumbs + variant price/unit-price/availability sync
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var main = root.querySelector('.pdp__main-img img');
    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) { main.src = b.getAttribute('data-src'); main.removeAttribute('srcset'); }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
    var dataEl = root.querySelector('[data-variants-json]');
    var select = root.querySelector('[data-variant-select]');
    if (!dataEl || !select) return;
    var variants = JSON.parse(dataEl.textContent);
    var priceEl = root.querySelector('[data-price]');
    var unitEl = root.querySelector('[data-unit-price]');
    var addBtn = root.querySelector('[data-add]');
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (unitEl) { unitEl.innerHTML = v.unit_html || ''; unitEl.hidden = !v.unit_html; }
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout'); }
      if (v.image && main) { main.src = v.image; main.removeAttribute('srcset'); }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
        var min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Collection sort select
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Home hero photo slider (autoplay ~5s, pause on hover, arrows/dots/keyboard)
  document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    var i = 0;
    var timer = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var show = function (n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var on = idx === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('hidden'); else s.setAttribute('hidden', '');
      });
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    };

    var next = function () { show(i + 1); };
    var prev = function () { show(i - 1); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () {
      if (reduced || root.getAttribute('data-paused') === '1') return;
      stop();
      timer = setInterval(next, interval);
    };

    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        show(parseInt(d.getAttribute('data-slider-dot'), 10) || 0);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); start(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); next(); start(); }
    });

    show(0);
    start();
  });

})();
